/* eslint-disable @typescript-eslint/no-explicit-any */

import { api, ApiResponse } from '@/api/api';
import { isAxiosError } from 'axios';
import { HOME_URLS } from '@/api/url';
import { CandidateWithJobContextBasicInfo } from '@/types/Candidate';
import { JobBasicInfo } from '@/types/Job';
import { MeetingSummary } from '@/types/Meeting';
import { Screening } from '@/types/Screening';

export interface GetHomeResponse {
  jobs: JobBasicInfo[];
  action_items: CandidateWithJobContextBasicInfo[];
  recent_screenings: Screening[];
  recent_meetings: MeetingSummary[];
  action_item_count: number;
}

export const apiGetHome = async (): Promise<ApiResponse<GetHomeResponse>> => {
  try {
    const response = await api.get<ApiResponse<GetHomeResponse>>(HOME_URLS.GET);
    return response.data;
  } catch (error: any) {
    if (isAxiosError(error)) {
      return error.response?.data;
    }

    throw error;
  }
};
